import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import emailIcon from "../assets/ic_email.svg";
import passwordIcon from "../assets/ic_password.svg";
import eyeIcon from "../assets/ic_eye.svg";
import loginImage from "../assets/logo.png";
import config from "../config";

const Login = ({ onLogin }) => {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});

  const validate = () => {
    const tempErrors = {};

    if (!email) {
      tempErrors.email = "Email is required";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      tempErrors.email = "Invalid email format";
    }

    if (!password) {
      tempErrors.password = "Password is required";
    }

    setErrors(tempErrors);

    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const response = await fetch(`${config.BASE_URL}/apis/admin-login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (data.success) {
         localStorage.setItem("isAuthenticated", "true"); // optional, can also do it in App.js onLogin
                       // React state update ho jati hai, jisse app samajhta hai ke user authenticated hai
        onLogin();
        navigate("/dashboard");
      } else {
        setErrors({ password: data.message });
      }
    } catch (error) {
      console.error("Login error:", error);
      setErrors({ password: "Server error. Please try again." });
    }
  };

  return (
    <div className="flex flex-col md:flex-row h-screen">
      {/* Left Side (Image) on top for mobile */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-6 order-1">
        <img
          src={loginImage}
          alt="Login"
          className="w-[150px] h-[150px] md:w-[200px] md:h-[200px] object-contain"
        />
      </div>

      {/* Divider */}
      <div className="hidden md:block w-[2px] bg-gray-300 my-20 order-2"></div>

      {/* Right Side (Form) on bottom for mobile */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-6 order-3">
        <form
          onSubmit={handleSubmit}
          className="w-full max-w-md px-4 text-center"
          noValidate
        >
          {/* Heading */}
          <h2 className="text-3xl font-bold text-[#FE7A36] mb-2">Welcome back</h2>
          <p className="text-gray-500 mb-6">Please, Sign in for admin access.</p>

          {/* Email Field */}
          <div className="relative mb-1 text-left">
            <img
              src={emailIcon}
              alt="email"
              className="absolute left-3 top-3 w-5 h-5"
            />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className={`w-full pl-10 pr-4 py-2 border-2 rounded focus:outline-none ${errors.email
                  ? "border-red-500 focus:border-red-500"
                  : "border-gray-300 focus:border-[#FE7A36]"
                }`}
            />
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">{errors.email}</p>
            )}
          </div>

          {/* Password Field */}
          <div className="relative mb-1 text-left mt-4">
            <img
              src={passwordIcon}
              alt="password"
              className="absolute left-3 top-3 w-5 h-5"
            />
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className={`w-full pl-10 pr-10 py-2 border-2 rounded focus:outline-none ${errors.password
                  ? "border-red-500 focus:border-red-500"
                  : "border-gray-300 focus:border-[#FE7A36]"
                }`}
            />
            <img
              src={eyeIcon}
              alt="toggle password"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-3 w-5 h-5 cursor-pointer select-none"
            />
            {errors.password && (
              <p className="text-red-500 text-sm mt-1">{errors.password}</p>
            )}
          </div>

          {/* Sign In Button */}
          <button
            type="submit"
            className="w-full mt-6 bg-[#FE7A36] text-white py-2 rounded hover:bg-[#e76828] transition-all duration-200"
          >
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
